
const initState = () => ({
  acceptedItemGroups: [],
  storeModuleFields: [],
  overrideComponentBasedPriceSetting: false,
  thresholdSetting: null,
  saveNewItemWithComponentBasedPriceAndCost: true,

  shippingMethods: [],
  priorityTypes: [],
  originalPromiseDate: null,
  copyItemImagesToJob: true,
  orderHasInvoice: false,
  orderCustomer: null,
})

export const state = initState

export const getters = {
}

export const mutations = {
  setAcceptedItemGroups(state, {acceptedItemGroups}){
    state.acceptedItemGroups = acceptedItemGroups;
  },
  setModuleFields(state, {moduleFields}){
    state.storeModuleFields = moduleFields;
  },
  setOverrideComponentBasedPriceSetting(state, overrideComponentBasedPriceSetting){
    state.overrideComponentBasedPriceSetting = overrideComponentBasedPriceSetting;
  },
  setThresholdSetting(state, thresholdSetting){
    state.thresholdSetting = thresholdSetting;
  },
  setShippingMethods(state, shippingMethods){
    state.shippingMethods = shippingMethods;
  },
  setPriorityTypes(state, priorityTypes){
    state.priorityTypes = priorityTypes;
  },
  setOriginalPromiseDate(state, originalPromiseDate){
    state.originalPromiseDate = originalPromiseDate;
  },
  setCopyItemImagesToJob(state, copyItemImagesToJob){
    state.copyItemImagesToJob = copyItemImagesToJob;
  },
  setOrderHasInvoice(state, orderHasInvoice){
    state.orderHasInvoice = orderHasInvoice;
  },
  setSaveNewItemWithComponentBasedPriceAndCost(state, saveNewItemWithComponentBasedPriceAndCost){
    state.saveNewItemWithComponentBasedPriceAndCost = saveNewItemWithComponentBasedPriceAndCost;
  },
  setOrderCustomer(state, customOrder){
    state.orderCustomer =
      customOrder
        ? {
          id: customOrder.customerID,
          customerCurrencyIsDifferentFromSystemCurrency: customOrder.customerCurrencyIsDifferentFromSystemCurrency,
          currencySymbol: customOrder.customerCurrencySymbol,
          customerCurrencyID: customOrder.customerCurrencyID,
          exchangeDate: customOrder.exchangeDate,
          exchangeRate: customOrder.exchangeRate,
          useRetailPrices: customOrder.useRetailPrices,
        }
        : null;
  },
}

export const actions = {

}
